import { extractErrorMessage } from './extract-error-message.helper';

interface ProviderConflictIdentifiers {
  npi?: string | null;
  emailAddress?: string | null;
}

export function formatProviderApiError(
  error: unknown,
  identifiers: ProviderConflictIdentifiers
): string {
  const apiMessage = extractErrorMessage(
    error,
    'An error occurred while submitting the provider. Please try again.'
  );
  const normalizedMessage = apiMessage.toLowerCase();
  const isDuplicate = ['already', 'exists', 'duplicate', 'used', 'in use']
    .some(term => normalizedMessage.includes(term));

  if (!isDuplicate) {
    return apiMessage;
  }

  const details: string[] = [];
  const npi = identifiers.npi?.trim();
  const emailAddress = identifiers.emailAddress?.trim();

  if (normalizedMessage.includes('npi') && npi && !normalizedMessage.includes(npi.toLowerCase())) {
    details.push(`NPI entered: ${npi}.`);
  }

  if (
    normalizedMessage.includes('email') &&
    emailAddress &&
    !normalizedMessage.includes(emailAddress.toLowerCase())
  ) {
    details.push(`Email address entered: ${emailAddress}. Please use a different email address.`);
  }

  if (!details.length) {
    return apiMessage;
  }

  const punctuatedApiMessage = /[.!?]$/.test(apiMessage.trim())
    ? apiMessage.trim()
    : `${apiMessage.trim()}.`;

  return `${punctuatedApiMessage} ${details.join(' ')}`;
}
